// has one main drawback, caret has to be at end of input
function ssnDirective () {
  return {
    require: 'ngModel',
    link: function (scope, elem, attr, ctrl) {
      var chars = [];
      elem.bind('click', function () {
      /**
       * Hack to prevent caret from being anywhere else other than the end
       * Could be good or bad from UX side, but helps prevent a lot of possible edge cases.
       * TODO: run this through voiceover just in case
       */
        elem.val(elem.val());
      });
      function formatString (text) {
        var unSeparatedString = text.replace(/-/g, ''); // this string has no dashes
        var lastChar = unSeparatedString[unSeparatedString.length - 1];
        chars.length = unSeparatedString.length; // truncate array if necessary
        if (lastChar !== '*') { // dont update array if the latest character was a *
          chars[unSeparatedString.length - 1] = lastChar; // update last value
        }
        var string = '';
        if (chars.length > 3) {
          string = '***-';
        } else {
          string += chars.slice(0, 3).join('');
        }
        if (chars.length > 5) {
          string += '**-';
        } else {
          string += chars.slice(3, 5).join('');
        }
        string += chars.slice(5, 9).join('');
        return string;
      }
      function parseSSN (text) {
        if (typeof text === 'string') {
          var formattedString = formatString(text);
          var rawString = chars.join('');
          ctrl.$setViewValue(formattedString);
          ctrl.$setValidity('pattern', chars.length === 9 && !isNaN(rawString));
          ctrl.$render();
          return rawString;
        }
        chars = [];
        return '';
      }
      function formatSSN (text) {
        if (typeof text !== 'string') {
          return;
        }
        chars = text.split('');
        return formatString(text);
      }
      ctrl.$parsers.push(parseSSN);
      ctrl.$formatters.push(formatSSN);
    }
  };
}

export default ssnDirective;



//////////////////
// WEBPACK FOOTER
// ./src/js/directives/ssnDirective.js
// module id = 34
// module chunks = 0